import React from 'react';
import parse from 'html-react-parser';
import { Icon } from '../Icon';

import './styles.scss';

interface Props {
    className?: string;
    flag: string;
    city: string;
}

export const Location = ({ flag, city, className = '' }: Props) => {
    return (
        <div className={`razem-app-location ${className}`}>
            <Icon icon='location-dot-solid' size='14px' color='info' className='razem-app-location__icon' />
            {parse(flag)}
            <span className='razem-app-location__city' title={city}>
                {city}
            </span>
        </div>
    );
};
